import { Tables } from "@/integrations/supabase/types";
import { fetchApi } from "./base";

export type AlertCardItem = {
  card: Tables<"cards"> & { set: Tables<"sets">; game: Tables<"games"> };
  alert: Tables<"price_alers">;
};

export type DealHunterFilters = {
  cardId: number;
  cardFormat: "any" | "raw" | "graded";
  condition:
    | "any"
    | "near_mint"
    | "lightly_played"
    | "moderately_played"
    | "heavily_played"
    | "damaged";
  printing:
    "any" | "normal" | "holofoil" | "reverse_holofoil" | "first_edition";
  minimumDiscountPercent: number;
};

export type DealHunterEntitlement = {
  tier: "free" | "collector_pro";
  hasFullAccess: boolean;
  maxResults: number;
};

export type ListingRiskFlag = {
  code:
    | "possible_reproduction"
    | "lot_or_bundle"
    | "stock_photo"
    | "low_seller_feedback"
    | "unusually_low_price";
  severity: "info" | "warning" | "high";
  label: string;
};

export type LiveDealListing = {
  source:
    | "ebay"
    | "tcgplayer"
    | "pricecharting"
    | "pokellama_marketplace"
    | "local_store";
  itemId: string;
  title: string;
  imageUrl: string | null;
  itemUrl: string;
  itemPrice: number;
  shippingPrice: number;
  totalPrice: number;
  currency: string;
  discountPercent: number;
  condition: string | null;
  sellerName: string | null;
  sellerFeedbackPercent: number | null;
  buyingOptions: string[];
  listedAt: string | null;
  riskFlags?: ListingRiskFlag[];
};

export type DealHunterListingsResponse = {
  success: true;
  data: {
    card: {
      id: number;
      name: string;
      number: string | null;
      setName: string | null;
      tcgplayerId: string | null;
    };
    referenceMarketPrice: number;
    minimumDiscountPercent: number;
    listings: LiveDealListing[];
    ebayResultCount: number;
    entitlement: DealHunterEntitlement;
  };
};

export function getAlerts() {
  return fetchApi<{
    success: boolean;
    data: AlertCardItem[];
  }>(`/api/price-alerts`, {
    method: "GET",
  });
}

export function getAlertsByCardId(cardId: number) {
  return fetchApi<any[]>(`/api/price-alerts/${cardId}`, {
    method: "GET",
  });
}

export function searchDealHunterListings(filters: DealHunterFilters) {
  const params = new URLSearchParams({
    cardId: String(filters.cardId),
    cardFormat: filters.cardFormat,
    condition: filters.condition,
    printing: filters.printing,
    minimumDiscountPercent: String(filters.minimumDiscountPercent),
  });

  return fetchApi<DealHunterListingsResponse>(
    `/api/price-alerts/deal-hunter/listings?${params.toString()}`,
    { method: "GET" },
  );
}
